import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const is404 = error?.status === 404;

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '2rem',
        }}>
            <Stack spacing={3} alignItems="center" style={{ maxWidth: 420, textAlign: 'center' }}>
                <ErrorOutlineIcon style={{ fontSize: 80, color: '#76A9AC' }} />

                <Typography variant="h4" style={{ fontWeight: 700, color: 'white' }}>
                    {is404 ? t('errorPageNotFound') : t('errorPageTitle')}
                </Typography>

                <Typography variant="body1" style={{ color: '#ffffffb0', lineHeight: 1.6 }}>
                    {is404 ? t('errorPageNotFoundDescription') : t('errorPageDescription')}
                </Typography>

                <Stack direction="row" spacing={2} style={{ paddingTop: '1rem' }}>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/app')}
                    >
                        {t('errorPageGoHome')}
                    </Button>
                    {!is404 && (
                        <Button
                            variant="outlined"
                            onClick={() => window.location.reload()}
                        >
                            {t('retry')}
                        </Button>
                    )}
                </Stack>
            </Stack>
        </div>
    );
};

export default ErrorPage;
